import Layout from "@/components/Layout";
import Seo from "@/components/Seo";

const TermsPage = () => (
  <Layout>
    <Seo title="Villkor – Aquadias användar- och avtalsvillkor" description="Användar- och avtalsvillkor för Aquadias dispenser- och prenumerationstjänst." path="/terms" />
    <section className="bg-gradient-to-b from-coral-500/20 via-cream-100 to-cream-50 py-20 md:py-32 px-6 md:px-12">
      <div className="max-w-3xl mx-auto prose prose-gray">
        <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-8">Användar- och avtalsvillkor</h1>
        <p className="text-sm text-muted-foreground mb-8">Senast uppdaterad: 1 mars 2026</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">1. Allmänt</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Dessa villkor reglerar kundens användning av de produkter och den utrustning som tillhandahålls av leverantören, Aquadias. Genom att använda produkterna och utrustningen accepterar kunden dessa villkor. Dispensern tillhandahålls under avtalets giltighetstid och förblir Aquadias egendom.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">2. Tjänstens omfattning</h2>
        <p className="text-muted-foreground leading-relaxed mb-2">Tjänsten omfattar:</p>
        <ul className="list-disc pl-6 text-muted-foreground leading-relaxed mb-4 space-y-1">
          <li>Dispenser för brustabletter ("Dispenser")</li>
          <li>Regelbundna leveranser av brustabletter med vitaminer och mineraler ("Produkter")</li>
        </ul>
        <p className="text-muted-foreground leading-relaxed mb-4">Dispensern är exklusivt avsedd för användning med Aquadias produkter och får inte användas med andra produkter.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">3. Avtalstid och uppsägning</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Avtalet löper tillsvidare med en (1) månads skriftlig uppsägningstid. Vid uppsägning ska dispensern returneras till Aquadias inom fyrtio (40) dagar i fungerande skick.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">4. Priser och betalning</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Kunden debiteras en fast månadsavgift baserat på avtalad volym. Betalning sker mot faktura med 30 dagars betalningsvillkor. Alla priser anges exklusive mervärdesskatt (moms).</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">5. Prisjusteringar</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Priserna gäller per kalenderår och kan justeras årligen. Eventuella prisändringar meddelas skriftligen senast 1 november för att gälla från 1 januari nästkommande år.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">6. Leverans och ändringar</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Dispensern levereras av Aquadias. Produkter skickas månadsvis eller kvartalsvis till den angivna leveransadressen. Kunden kan ändra produktsammansättning genom att meddela Aquadias senast den 15:e varje månad.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">7. Kundens ansvar</h2>
        <p className="text-muted-foreground leading-relaxed mb-2">Kunden ansvarar för att:</p>
        <ul className="list-disc pl-6 text-muted-foreground leading-relaxed mb-4 space-y-1">
          <li>Använda produkterna enligt instruktioner</li>
          <li>Hantera och vårda dispensern</li>
          <li>Informera om oöppnade tuber inför leverans</li>
          <li>Rapportera eventuella tekniska problem</li>
        </ul>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">8. Support och underhåll</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Aquadias tillhandahåller support och underhåll av utrustning samt byter ut defekta produkter eller utrustning vid normal användning.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">9. Reklamationer</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Reklamationen ska ske skriftligen inom fjorton (14) dagar från leverans. Aquadias åtar sig att åtgärda eventuella brister inom rimlig tid.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">10. Livsmedelssäkerhet</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Kunden ska omgående rapportera misstänkta problem relaterade till produktsäkerhet. Aquadias hanterar incidenter enligt gällande lagstiftning.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">11. Ansvarsbegränsning</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Aquadias ansvarar inte för indirekta skador eller skador som uppstår vid felaktig användning.</p>

        <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">12. Tillämplig lag</h2>
        <p className="text-muted-foreground leading-relaxed mb-4">Dessa villkor regleras av svensk lag. Tvister avgörs av svensk allmän domstol.</p>
      </div>
    </section>
  </Layout>
);

export default TermsPage;
